export default __webpack_public_path__ + "static/media/blog3.4826190b.svg";